import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo } from 'react';
import { Select, useLocalizeMessage } from 'libs.nucleus';
export const StudyVersionsDropdown = ({ setSelectedStudyVersion, selectedStudyVersion, versions, }) => {
    const translate = useLocalizeMessage();
    useEffect(() => {
        if (versions.size) {
            setSelectedStudyVersion(versions.values().next().value);
        }
    }, [versions]);
    const handleChange = useCallback((selectedOption) => {
        const currentVersion = versions.get(selectedOption.value);
        setSelectedStudyVersion(currentVersion);
    }, [setSelectedStudyVersion, versions]);
    const versionsOptions = useMemo(() => {
        return Array.from(versions.values()).map((version) => ({
            value: version.id,
            label: `${version.metadata.name} (${version.externalVersion})`,
        }));
    }, [versions]);
    const currentVersion = useMemo(() => {
        if (!selectedStudyVersion) {
            return { label: '', value: '' };
        }
        return {
            value: selectedStudyVersion.id,
            label: `${selectedStudyVersion.metadata.name} (${selectedStudyVersion.externalVersion})`,
        };
    }, [selectedStudyVersion]);
    return (_jsx("div", { className: 'relative', children: _jsx(Select, { options: versionsOptions, value: currentVersion, onChange: handleChange, width: 'lg', required: true, label: translate('Study versions') }) }));
};
